import { Text } from "../../../../atoms/Text";
import type { StatusToken } from "../statusTokens";
import { StatusDot } from "./StatusDot";

interface StatusWordProps {
  token: StatusToken;
}

/** Dot plus word, for places with room for both (hover card, meta lines). */
export const StatusWord = ({ token }: StatusWordProps) => (
  <span className="inline-flex items-center gap-1.5">
    <StatusDot color={token.color} />
    <Text
      as="span"
      variant="inherit"
      color="secondary"
      className="whitespace-nowrap text-(length:--ledger-text-cell) leading-[1.66]"
    >
      {token.word}
    </Text>
  </span>
);
